/** 
 * Constants used across application.
 */
const konstants = (() => {
    return {
        FORMS: {
            FETCHING_FORM: 'FORMS:FETCHING_FORM',
            FORM_FETCHED: 'FORMS:FORM_FETCHED',
        },
        USER: {
            LOGIN: 'USER:LOGIN',
            USER_LIST: 'USER:USER_LIST',
            USER_DETAILS_SUCCESS: 'USER:USER_DETAILS_SUCCESS',
        },
        STOCKS: {
            STOCK_LIST: 'STOCKS:STOCK_LIST',
            VALIDATE_STOCK_RESULT: 'STOCKS:VALIDATE_STOCK_RESULT',
            INDICATOR_LIST: 'STOCKS:INDICATOR_LIST'
        },
        CONFIGURATION: {
            CONFIGURATION_LIST: 'CONFIGURATION:CONFIGURATION_LIST',
            GET_CONFIGURATION_SUCCESS: 'CONFIGURATION:GET_CONFIGURATION_SUCCESS',
            SAVE_CONFIGURATION_SUCCESS: 'CONFIGURATION:SAVE_CONFIGURATION_SUCCESS',
            ZERODHA_LOGIN_CONFIG: 'CONFIGURATION:ZERODHA_LOGIN_CONFIG',
            ZERODHA_SAVE_CONFIG: 'CONFIGURATION:ZERODHA_SAVE_CONFIG',
        },
        LEVERAGE: {
            LEVERAGE_LIST: 'LEVERAGE:LEVERAGE_LIST',
        },
        ADMIN: {
            CRONJOB_LIST: 'ADMIN:CRONJOB_LIST',
            TRADE_ALERT_LIST: 'ADMIN:TRADE_ALERT_LIST',
            ACTIONS_COMPLETE: 'ADMIN:ACTIONS_COMPLETE',
            ACCESS_CONTROL_LIST: 'ADMIN:ACCESS_CONTROL_LIST',
            SAVE_ACCESS_CONTROL_LIST: 'ADMIN:SAVE_ACCESS_CONTROL_LIST',
            HISTORY_DATE_SUMMARY: 'ADMIN:HISTORY_DATE_SUMMARY'
        },
        STRATEGY: {
            APPLY_STRATEGY: 'STRATEGY:APPLY_STRATEGY'
        },
        TRACKING: {
            TRACKING_LIST: 'TRACKING:TRACKING_LIST',
            TRACKING_DETAILS_SUCCESS: 'TRACKING:TRACKING_DETAILS_SUCCESS',
            SAVE_TRACKING: 'TRACKING:SAVE_TRACKING',
            GET_TRACKING: 'TRACKING:GET_TRACKING'
        },
        HOME: {
            TRACKING_LIST: 'HOME:TRACKING_LIST',
            TRACKING_CHART_DATA: 'TRACKING_CHART_DATA'
        },
        TAGS: {
            LIST_TAGS: 'TAGS:LIST_TAGS',
            GET_TRACKING: 'TAGS:GET_TRACKING',
            SAVE_TRACKING: 'TAGS:SAVE_TRACKING',
        },
        ZERODHA: {
            LIST_HOLDINGS: 'ZERODHA:LIST_HOLDINGS',
            LIST_INSTRUMENTS: 'ZERODHA:LIST_INSTRUMENTS',
            LIST_TRADES: 'ZERODHA:LIST_TRADES',
            UPDATE_TRADE: 'ZERODHA:UPDATE_TRADE',
            EXECUTE_TRADE: 'ZERODHA:EXECUTE_TRADE',
            HOLDINGS_CHART_DATA: 'ZERODHA:HOLDINGS_CHART_DATA',
            TRACK_TRADE_LISTING: 'ZERODHA:TRACK_TRADE_LISTING'
        }
    };
})();

export default konstants;
